<template>
    <div :style="{ '--bg-image': `url(${require('@/assets/not-found.jpg')})` }" >
        <p>A página não foi encontrada</p>
      </div>
</template>
<style scoped>
.img {
    max-width: 100%;

}
.background-image {
  background-image: var(--bg-image);
  /* Outras propriedades de background, como tamanho, posição, etc. */
}


</style>